export function initFixedBreadcrumbs() {
  const breadcrumbs = document.querySelector('.breadcrumbs-section');
  const fixedClass = 'fixed';
  const addDelayMs = 600;

  if (!breadcrumbs) return;

  let sectionBottom = 0;
  let ticking = false;
  let addTimeoutId = null;

  const updateSectionBottom = () => {
    sectionBottom = breadcrumbs.offsetTop + breadcrumbs.offsetHeight;
  };

  const scheduleAddFixed = () => {
    if (breadcrumbs.classList.contains(fixedClass) || addTimeoutId) return;

    addTimeoutId = window.setTimeout(() => {
      addTimeoutId = null;
      if (window.scrollY > sectionBottom) {
        breadcrumbs.classList.add(fixedClass);
      }
    }, addDelayMs);
  };

  const removeFixedImmediately = () => {
    if (addTimeoutId) {
      window.clearTimeout(addTimeoutId);
      addTimeoutId = null;
    }

    breadcrumbs.classList.remove(fixedClass);
  };

  const updateFixedState = () => {
    ticking = false;

    if (window.scrollY > sectionBottom) {
      scheduleAddFixed();
      return;
    }

    removeFixedImmediately();
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateFixedState);
  };

  updateSectionBottom();
  updateFixedState();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    updateSectionBottom();
    onScroll();
  });
}
